// extracted by mini-css-extract-plugin
export default {"canvasPreLoad":"canvasPreLoad_canvasPreLoad__i-sDP","sizeTips":"canvasPreLoad_sizeTips__hVqMA"};